import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import { colorCategories } from '@deck.gl/carto';

export const BROWARDFUTURELANDUSE_LAYER_ID = 'browardFutureLandUseLayer';

const COLORS = [
  [54, 122, 48],
  [158, 31, 7],
  [13, 79, 42],
  [85, 138, 116],
  [166, 166, 166],
  [8, 140, 93],
  [204, 198, 84],
  [204, 171, 38],
  [51, 51, 51],
  [36, 67, 148],
];
const LABELS = [
  'Agricultural',
  'Commercial',
  'Community Facilities',
  'Conservation',
  'Industrial',
  'Open Space',
  'Residential',
  'Rural',
  'Transportation',
  'Water',
];

const layerConfig = {
  title: 'Future Land Use',
};

function BrowardFutureLandUseLayer() {
  const dispatch = useDispatch();
  const { browardFutureLandUseLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardFutureLandUseLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardFutureLandUseLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDFUTURELANDUSE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardFutureLandUseLayer.visible,
      opacity: browardFutureLandUseLayer.opacity,
      getFillColor: colorCategories({
        attr: 'Generalized_Category',
        domain: LABELS,
        colors: COLORS,
      }),
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDFUTURELANDUSE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Future Land Use Details',
              includeColumns: [
                'Land_Use_Code',
                'Land_Use_Code_Description',
                'Generalized_Category',
                'Land_Use_Area_Acres',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardFutureLandUseLayer;
